import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { TranslateModule } from '@ngx-translate/core'
import { AngularSvgIconModule } from 'angular-svg-icon'
import { ButtonFlatModule, ButtonIconModule, ButtonStrokedModule } from '../../../shared/directives/button'
import { SITE_MENU } from '../../configs/dashboard-config'
import { DASHBOARD_SIDEBAR_MENU } from '../../injectors/dashboard.injector'
import { DashboardLayoutSidebarClientComponent } from './dashboard-layout-sidebar/dashboard-layout-sidebar-client/dashboard-layout-sidebar-client.component'
import { DashboardLayoutSidebarComponent } from './dashboard-layout-sidebar/dashboard-layout-sidebar.component'
import { DashboardLayoutTopbarLanguageChangeComponent } from './dashboard-layout-topbar/dashboard-layout-topbar-lang-change/dashboard-layout-topbar-lang-change.component'
import { NotificationSettingsComponent } from './dashboard-layout-topbar/dashboard-layout-topbar-settings/components/notification-settings/notification-settings.component'
import { NotificationSettingsModalComponent } from './dashboard-layout-topbar/dashboard-layout-topbar-settings/modals/notification-settings-modal/notification-settings-modal.component'
import { SettingApiService } from './dashboard-layout-topbar/dashboard-layout-topbar-settings/services/setting-api.service'
import { DashboardLayoutTopbarUserComponent } from './dashboard-layout-topbar/dashboard-layout-topbar-user/dashboard-layout-topbar-user.component'
import { DashboardLayoutTopbarComponent } from './dashboard-layout-topbar/dashboard-layout-topbar.component'
import { DashboardLayoutComponent } from './dashboard-layout.component'

@NgModule({
    declarations: [
        DashboardLayoutComponent,
        DashboardLayoutSidebarComponent,
        DashboardLayoutTopbarComponent,
        DashboardLayoutTopbarUserComponent,
        DashboardLayoutSidebarClientComponent,
        DashboardLayoutTopbarLanguageChangeComponent,
        NotificationSettingsComponent,
        NotificationSettingsModalComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        AngularSvgIconModule,
        TranslateModule,
        ButtonIconModule,
        NgSelectModule,
        ReactiveFormsModule,
        NgbDropdownModule,
        ButtonStrokedModule,
        ButtonFlatModule,
        NgbTooltipModule
    ],
    providers: [{ provide: DASHBOARD_SIDEBAR_MENU, useValue: SITE_MENU }, SettingApiService]
})
export class DashboardLayoutModule {}
